<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div>

		<!-- Sign Up Image And Headings -->
		<div class="sign-up-header" style="background-image: url('/images/signupbg.png')">
			<div class="content">
				<h1 class="mb-5">Sign Up</h1>
				<p class="text-lg">Register using any of the following methods and start using Pairplex today.</p>
			</div>
		</div>
		<!-- / Sign Up Image And Headings -->
		
		<!-- Sign Up Form -->
		<a-card :bordered="false" class="card-signup header-solid h-full" :bodyStyle="{paddingTop: 0}">
			<template #title>
				<h5 class="font-semibold text-center">Register With</h5>
			</template>
			<div class="sign-up-gateways">
    			<a-button>
					<img src="/images/logos/logos-facebook.svg" alt="">
				</a-button>
    			<a-button>
					<img src="/images/logos/logo-apple.svg" alt="">
				</a-button>
    			<a-button>
					<img src="/images/logos/Google__G__Logo.svg.png" alt="">
				</a-button>
			</div>
			<p class="text-center my-25 font-semibold text-muted">Or</p>
			<a-form
				id="components-form-demo-normal-login"
				:form="form"
				class="login-form"
				@submit="handleSubmit"
			>
				<a-form-item class="mb-10">
					<a-input
						v-decorator="[
						'firstname',
						{ rules: [{ required: true, message: 'Please input your firstname!' }] },
						]"
						placeholder="Firstname"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-10">
					<a-input
						v-decorator="[
						'lastname',
						{ rules: [{ required: true, message: 'Please input your lastname!' }] },
						]"
						placeholder="Lastname"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-10">
					<a-input
						v-decorator="[
						'email',
						{ rules: [{ required: true, message: 'Please input your email!' }, { type: 'email', message: 'Please fill in a valid email address.' }] }
						]"
						placeholder="Email"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-5">
					<a-input
						v-decorator="[
						'password',
						{ rules: [{ required: true, message: 'Please input your Password!' }, { min: 8, message: 'Password must be at least 8 characters.' }] },
						]"
						type="password"
						placeholder="Password"
					>
					</a-input>
				</a-form-item>
				<a-form-item class="mb-10">
					<a-checkbox
						v-decorator="[
						'remember',
						{
							valuePropName: 'checked',
							initialValue: true,
						},
						]"
					>
						I agree the <a href="#" class="font-bold text-dark">Terms and Conditions</a>
					</a-checkbox>
				</a-form-item>
				<a-form-item>
					<a-button type="primary" block html-type="submit" class="login-form-button">
						SIGN UP
					</a-button>
				</a-form-item>
			</a-form>
			<p class="font-semibold text-muted text-center">Already have an account? <router-link to="/sign-in" class="font-bold text-dark">Sign In</router-link></p>
		</a-card>
		<!-- / Sign Up Form -->

	</div>
</template>

<script>
import axios from 'axios';

export default {
	data() {
		return {
			error: '', // Voor foutmeldingen
		};
	},
	beforeCreate() {
		// Maak het formulier en voeg validatie toe
		this.form = this.$form.createForm(this, { name: 'normal_signup' });
	},
	methods: {
		// Afhandelen van formulierverzending
		async handleSubmit(e) {
			e.preventDefault();
			this.form.validateFields(async (err, values) => {
				if (!err) {
					try {
						// Verstuur verzoek naar backend
						const response = await axios.post('https://pairplex.online/api/createUser', {
							firstname: values.firstname,
							lastname: values.lastname,
							email: values.email,
							passwordhash: values.password,
						});

						// Check op succesvolle aanmaak
						if (response.status === 201) {
							this.$router.push('/sign-in');
						} else {
							this.error = response.data.message || 'Er ging iets mis.';
						}
					} catch (error) {
						// Toon foutmelding bij mislukking
						this.error = error.response?.data?.message || 'Signup mislukt. Controleer uw invoer.';
					}
				} else {
					this.error = 'Controleer uw formulier op fouten.';
				}
			});
		},
	},
};
</script>



<style lang="scss">
</style>